// @ts-nocheck
import { useState, useEffect } from 'react';
import Fetch from '@/utils/Fetch';
import styles from './CustomerZoneDetail.module.css';

export default function CustomerZoneMessageModal({ module, itemID, t, c, tenant, onClose }: any) {
  const [contacts, setContacts] = useState<any[]>([]);
  const [contactID, setContactID] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    Fetch.get({ url: '/CustomerZone/GetCustomer', params: { customerID: c }, tenantID: t, customerID: c, apiUrlOverride: tenant.API })
      .then((customer: any) => {
        const ctcs = customer?.Contacts || [];
        setContacts(ctcs);
        if (ctcs.length === 1) setContactID(ctcs[0].ID);
      });
  }, []);

  const handleSend = async () => {
    if (!message.trim()) { setError('Please enter a message.'); return; }
    if (contacts.length > 1 && !contactID) { setError('Please select a contact.'); return; }
    setSending(true);
    setError('');
    try {
      const result = await Fetch.post({
        url: '/CustomerZone/Message',
        params: { message: message.trim(), module, itemID, customerContactID: contactID },
        tenantID: t, customerID: c, apiUrlOverride: tenant.API,
      });
      if (result) setSent(true);
      else setError('Could not send message. Please try again.');
    } catch {
      setError('Could not send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={styles.modalScrim} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={styles.modal} role="dialog" aria-modal="true">
        {sent ? (
          <>
            <p className={styles.modalTitle}>Message sent</p>
            <p className={styles.modalBody}>Your message has been sent. The team will follow up with you shortly.</p>
            <div className={styles.modalActions}>
              <button className={styles.act} type="button" onClick={onClose}>Close</button>
            </div>
          </>
        ) : (
          <>
            <p className={styles.modalTitle}>Leave a comment</p>
            {contacts.length > 1 && (
              <div className={styles.signField}>
                <label className={styles.signLabel}>From</label>
                <select
                  className={styles.signInput}
                  value={contactID}
                  onChange={e => setContactID(e.target.value)}
                  style={{ minHeight: 'unset', resize: 'none' }}
                >
                  <option value="">Select contact…</option>
                  {contacts.map((ct: any) => (
                    <option key={ct.ID} value={ct.ID}>
                      {ct.FullName || `${ct.FirstName || ''} ${ct.LastName || ''}`.trim()}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className={styles.signField}>
              <label className={styles.signLabel}>Message</label>
              <textarea
                className={styles.signInput}
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="Type your question or comment…"
                rows={4}
                autoFocus
              />
            </div>
            {error && <p className={styles.modalBody} style={{ color: '#fc2e50' }}>{error}</p>}
            <div className={styles.modalActions}>
              <button className={styles.act} type="button" onClick={onClose} disabled={sending}>Cancel</button>
              <button
                className={`${styles.act} ${styles.actPrimary}`}
                type="button"
                onClick={handleSend}
                disabled={sending || !message.trim()}
              >
                {sending ? 'Sending…' : 'Send'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
